

if (!window.module) {
    window.module = {};
}

module.accordion = (function (global) {
    "use strict";

    var controls = {},
        handlers = {
            clickItems: function (event) {
                var items = controls.items,
                    count = items.length,
                    i;

                if (this.checked) {
                    for (i = 0; i < count; i++) {
                        if (items[i] === this) {
                            continue;
                        }

                        items[i].checked = false;
                    }
                }
            }
        };

    function setEventList() {
        global.addEvents(controls.items, 'change', handlers.clickItems);
    }

    function getControls() {
        controls.items = document.querySelectorAll('.additional-option input');
    }

    function init(params) {
        getControls();
        setEventList();
    }

    return {
        init: init
    };

}(DALGAKIRAN.global));

window.addEventListener('DOMContentLoaded', function () {

    module.accordion.init({

    });

}, false);
